import { render, staticRenderFns } from "./GlobalSettingsDialog.vue?vue&type=template&id=da9921ac&"
import script from "./GlobalSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./GlobalSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSettingsDialog.vue?vue&type=style&index=0&id=da9921ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports